import type { ZodType, z } from "zod";

export const trimmedNullable = (
	schema: ZodType<string>,
): ZodType<string | null, z.ZodTypeDef, string> =>
	schema.transform((val) => {
		const trimmed = val.trim();
		return trimmed === "" ? null : trimmed;
	});
